import { Alert, Button, Typography } from '@material-tailwind/react'
import { colors } from '@material-tailwind/react/types/generic'
import { PiSpeakerX, PiSwap } from 'react-icons/pi'
import { useTranslation } from 'react-i18next'
import WavesurferPlayerControls from './WavesurferPlayerControls'
import { useDarkMode } from '../contexts/DarkModeContext'

interface AgamiAudioFilePreviewProps {
  audioLabel?: string
  audioUrl?: string
  openFileDialog: () => void
}

const AgamiAudioFilePreview: React.FC<AgamiAudioFilePreviewProps> = ({
  audioLabel,
  audioUrl,
  openFileDialog,
}) => {
  const { t } = useTranslation()
  const { darkMode } = useDarkMode()

  return (
    <div
      className="w-full flex flex-col gap-4 text-center justify-start items-start mt-4"
      data-testid="agami-audio-file-preview"
    >
      <div className="flex flex-col md:flex-row justify-start md:justify-center items-start md:items-center gap-2">
        <Typography className="font-bold text-xl font-barlow" data-testid="agami-audio-file-preview-label">
          {audioLabel ?? 'N/A'}
        </Typography>
        <Button
          variant="outlined"
          size="sm"
          onClick={openFileDialog}
          className="flex justify-center items-center gap-1"
          color={darkMode ? 'white' : ('primary' as colors)} // eslint-disable-line @typescript-eslint/no-explicit-any
          data-testid="agami-audio-file-preview-replace-btn"
        >
          <PiSwap className="h-4 w-4" />
          {t('videoFile.replace')}
        </Button>
      </div>

      <div className="w-full mt-1 xl:p-4">
        {audioUrl ? (
          <WavesurferPlayerControls audioUrl={audioUrl} />
        ) : (
          <Alert
            color="orange"
            className="w-full md:w-1/2 py-2 px-4 mt-2 text-xs"
            icon={<PiSpeakerX className="w-4 h-4" />}
          >
            We couldn't find this audio file
          </Alert>
        )}
      </div>
    </div>
  )
}

export default AgamiAudioFilePreview
